import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const Watchlist = React.lazy(() =>
    import('../Watchlist')
);
const watchlistRoutesRegistry = [
    {
        path: PAGE_URL.WATCHLIST_PAGE,
        element: <Watchlist />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default watchlistRoutesRegistry;
